<template>
    <div class="help" id="help">
       <app-header v-if="header_show"></app-header>
       <!-- 我的测评 -->
       <div class="content">
         <div class="curmbs">
           <span class="left" @click="toIndex">首页 ></span>
           <span class="checked">帮助中心</span>
         </div>
        <div class="table">
          <div class="th">
            <span class="title">标题</span>
            <span class="classify">分类</span>
            <span class="time">发布日期</span>
          </div>
          <div class="tr checked" @click="toDetail">
            <span class="title">第五届全国“学宪法 讲宪法“活动开始啦！</span>
            <span class="classify">培训要求</span>
            <span class="time">2020/06/17</span>
          </div>
          <div class="tr" @click="toDetail">
            <span class="title">第五届全国“学宪法 讲宪法“活动开始啦！</span>
            <span class="classify">培训要求</span>
            <span class="time">2020/06/17</span>
          </div>
          <div class="tr checked" @click="toDetail">
            <span class="title">第五届全国“学宪法 讲宪法“活动开始啦！</span>
            <span class="classify">培训要求</span>
            <span class="time">2020/06/17</span>
          </div>
          <div class="tr" @click="toDetail">
            <span class="title">第五届全国“学宪法 讲宪法“活动开始啦！</span>
            <span class="classify">培训要求</span>
            <span class="time">2020/06/17</span>
          </div>
          <div class="tr checked"></div>
          <div class="tr"></div>
          <div class="tr checked"></div>
        </div>


        <div class="page-bar">
            <ul>
                <li v-if="cur>1"><a v-on:click="cur--,pageClick()">上一页</a></li>
                <li v-if="cur==1"><a class="banclick">上一页</a></li>
                <!--当前页背景色为蓝色-->
                <li v-for="index in indexs"  v-bind:class="{ 'active': cur == index}">
                    <a v-on:click="btnClick(index)">{{ index }}</a>
                </li>
                <li v-if="cur<all"><a v-on:click="cur++,pageClick()">下一页</a></li>
                <li v-if="cur == all"><a class="banclick">下一页</a></li>
                <li><a>共<i>{{all}}</i>页</a></li>
            </ul>
        </div>
       </div>
    </div>
</template>

<script>
  import Header from '@/components/Header'
  export default {
    name: 'help',
    components: {
      'app-header':Header,
    },
    data () {
      return {
        header_show:true,
        all: 8, //总页数
        cur: 1//当前页码
      }
    },
    watch: {
      cur: function(oldValue , newValue){
          console.log(arguments);
      }
    },
    methods: {
      toIndex(){
        this.$router.push('index');
      },
      toDetail(){
        this.$router.push('./helpdetail');
      },
      btnClick: function(data){
          if(data != this.cur){
              this.cur = data;
          }
      },
      pageClick: function(){
          console.log('现在在'+this.cur+'页');
      }
    },
    computed: {
      indexs: function(){
        var left = 1;
        var right = this.all;
        var ar = [];
        if(this.all>= 5){
          //这里最大范围从3到6，如果到达7，那么下边加2变成9，已经超过最大的范围值
          if(this.cur > 3 && this.cur < this.all-1){
            //以4为参考基准，左面加2右边加2
                  left = this.cur - 2
                  right = this.cur + 2
          }else{
              if(this.cur<=3){
                  left = 1
                  right = 5
              }else{
                  right = this.all
                  left = this.all -4
              }
          }
       }
      while (left <= right){
          ar.push(left)
          left ++
      }
      console.log(ar);
      return ar
     }
    }
  }
</script>
<style scoped>
.content{
  width: 15rem;
  margin: 0 auto;
  padding-bottom: 0.84rem;
}
.content .curmbs{
  width: 100%;
  height: 1.03rem;
  line-height: 1.03rem;
}
.content .curmbs .left{
  float: left;
  font-size: 0.25rem;
  color: #404040;
  margin-left: 0.32rem;
  cursor: pointer;
}
.content .curmbs .checked{
  float: left;
  font-size: 0.25rem;
  color: #2b73cc;
}

.content .table{
  width: 100%;
}
.content .table .th{
  width: 100%;
  height: 0.7rem;
  line-height: 0.7rem;
  background-color: #c1cdba;
}
.content .table .th .title{
  float: left;
  font-size: 0.25rem;
  color: #fff;
  width: 7.95rem;
  margin-left: 1.68rem;
}
.content .table .th .classify{
  float: left;
  font-size: 0.25rem;
  color: #fff;
  width: 2.34rem;
}
.content .table .th .time{
  float: left;
  font-size: 0.25rem;
  color: #fff;
  width: 2.34rem;
}
.content .table .tr{
  width: 100%;
  height: 0.7rem;
  line-height: 0.7rem;
  background-color: #fff;
  cursor: pointer;
}
.content .table .checked{
  background-color: #f0f0f0 !important;
}
.content .table .tr .title{
  float: left;
  font-size: 0.25rem;
  color: #6e6e6e;
  width: 7.95rem;
  margin-left: 1.68rem;
}
.content .table .tr .classify{
  float: left;
  font-size: 0.25rem;
  color: #6e6e6e;
  width: 2.34rem;
}
.content .table .tr .time{
  float: left;
  font-size: 0.25rem;
  color: #6e6e6e;
  width: 2.34rem;
}





/*分页*/
.page-bar{
    margin:40px;
}
ul,li{
    margin: 0px;
    padding: 0px;
}
li{
    list-style: none;
    font-size: 0.21rem;
}
.page-bar li:first-child>a {
   margin-left: 0px
}
.page-bar a{
    border: 1px solid #ddd;
    text-decoration: none;
    position: relative;
    float: left;
    padding: 6px 12px;
    margin-left: -1px;
    line-height: 1.42857143;
    color: #337ab7;
    cursor: pointer
}
.page-bar a:hover{
    background-color: #eee;
}
.page-bar a.banclick{
    cursor:not-allowed;
}
.page-bar .active a{
    color: #fff;
    cursor: default;
    background-color: #337ab7;
    border-color: #337ab7;
}
.page-bar i{
    font-style:normal;
    color: #d44950;
    margin: 0px 4px;
    font-size: 0.21rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Help.vue